export default __webpack_public_path__ + "static/media/eric.df0ae3f7.jpg";